import React, { useLayoutEffect } from 'react'
import PaymentForm from '../../sections/paymentForm/PaymentForm'
import { usePaymentContext } from '@/contexts/PaymentContext'
import { useAppNavigate } from '@/hooks/useAppNavigate'
import { APP_ROUTES } from '@/config/routes.config'

const PaymentAdvance = () => {
  const {
    state: { apiPaymentData },
    setError,
  } = usePaymentContext()

  const { advancePrice, paidTypeAdvanceId, advancePaid } = apiPaymentData ?? {}
  const { navigate } = useAppNavigate()

  useLayoutEffect(() => {
    if (advancePaid) {
      navigate({
        pathname: APP_ROUTES.PAYMENT,
        replace: true,
      })
    }
  }, [])

  return (
    <PaymentForm
      priceToPay={advancePrice}
      paidTypeId={paidTypeAdvanceId!}
      onPaymentError={(e) => {
        setError({
          message: e.message,
        })
        navigate({
          pathname: APP_ROUTES.PAYMENT,
          replace: true,
        })
      }}
      onPaymentSuccess={() => {
        navigate({
          pathname: APP_ROUTES.PAYMENT,
          replace: true,
        })
      }}
    />
  )
}

export default PaymentAdvance
